export const useExportGoogleFile = async ({
  fileId,
  fileName,
  fileType,
  accessToken,
}: {
  fileId: string;
  fileName: string;
  fileType: string;
  accessToken: string;
}): Promise<CustomFile | undefined> => {
  const exportMimeType =
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  
  // Determine if this is a Google Doc (needs export) or an uploaded file (needs download)
  const isGoogleDoc = fileType === "application/vnd.google-apps.document";
  
  // Use export endpoint for Google Docs, download endpoint for uploaded files
  const fileUrl = isGoogleDoc
    ? `https://www.googleapis.com/drive/v3/files/${fileId}/export?mimeType=${encodeURIComponent(exportMimeType)}`
    : `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;
  
  try {
    const response = await fetch(fileUrl, {
      headers: new Headers({
        Authorization: `Bearer ${accessToken}`,
      }),
    });
    if (!response.ok) throw new Error("Failed to download file");
    const blob = await response.blob();
    // Convert blob to Uint8Array
    const arrayBuffer = await blob.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    // Use appropriate extension based on whether we're exporting or downloading
    const fileExtension = isGoogleDoc ? ".docx" : "";
    const finalFileName = fileName.endsWith(".docx") ? fileName : `${fileName}${fileExtension}`;

    const customFile = {
      data: uint8Array,
      name: finalFileName,
      size: blob.size,
      type: isGoogleDoc ? exportMimeType : fileType,
    } as CustomFile;

    return customFile;
  } catch (error) {
    console.error("Error downloading or uploading file:", error);
  }
};
